import {useState} from 'react';

import Image from '../../../../../components/Image/Image';
import {LightButton} from '../../../../../components/Inputs/Button';
import awsRumActionNames from '../../../../../consts/aws/awsRumActionNames';
import awsRumActionTypes from '../../../../../consts/aws/awsRumActionTypes';
import {strCode} from '../../../../../consts/strCode';
import rumCustomEvents from '../../../../../services/events/rumCustomEvents';
import {t} from '../../../../../services/localization/localizationService';
import TEREA_CONFIG from './config';

const ClubPageMostPopularFlavours = ({onNextStory}) => {
    const [checked, setChecked] = useState(null);

    const onChange = (id) => {
        rumCustomEvents.recordAction({action: awsRumActionTypes.SELECT, rumActionName: id});
        setChecked((prev) => (prev === id ? null : id));
    };

    return (
        <>
            <div className='pointer-events-auto flex h-full w-full flex-col gap-4 overflow-y-auto pt-4'>
                {TEREA_CONFIG.map(({imageSrc, id, titleStrCode}) => (
                    <div
                        className='flex w-full shrink-0 items-center justify-center gap-4'
                        key={id}
                        onClick={() => onChange(id)}
                    >
                        <div className='relative flex'>
                            <Image src={imageSrc} className='h-full' />
                            <p className='absolute inset-0 ml-[55%] flex items-center text-14 text-color-romance'>
                                {t(titleStrCode)}
                            </p>
                        </div>
                        <label className='flex h-6 w-6 cursor-pointer gap-3'>
                            <input onChange={() => onChange(id)} type='checkbox' className='hidden' />
                            <div className='relative h-[22px] w-[22px] shrink-0 cursor-pointer rounded-full border-2 border-color-romance'>
                                {checked === id && (
                                    <div className='absolute left-1/2 top-1/2 h-[12.2px] w-[12.2px] shrink-0 -translate-x-1/2 -translate-y-1/2 rounded-full bg-color-tertiary' />
                                )}
                            </div>
                        </label>
                    </div>
                ))}
            </div>
            <LightButton
                disabled={checked === null}
                className='pointer-events-auto mt-auto'
                onClick={onNextStory}
                rumActionName={awsRumActionNames.TICKED}
            >
                {t(strCode.CLUB_PAGE_STORIES_MOST_POPULAR_FLAVOURS_2_BTN)}
            </LightButton>
        </>
    );
};

export default ClubPageMostPopularFlavours;
